// Exclusive options (e.g. "I'm open to anywhere.") are declared per-question:
// selecting one clears the other selections, and selecting a specific option clears it.
export const toggleMultiSelectOption = (
  selected: readonly string[],
  option: string,
  exclusiveOptions: readonly string[] = [],
): string[] => {
  if (selected.includes(option)) {
    return selected.filter((item) => item !== option);
  }

  if (exclusiveOptions.includes(option)) {
    return [option];
  }

  return [...selected.filter((item) => !exclusiveOptions.includes(item)), option];
};
